import React from 'react';

// ----------------------------------------------------------------------

export default function SearchDesciption({ desc }) {

return (
  <div className="region region-content">
    <section id="block-system-main" className="block block-system">
      <div className="content mrgn-tp-md published">
        <div className="field field-name-body field-type-text-with-summary field-label-hidden">
          <div className="field-items">
            <div className="field-item even">
              {desc}
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  );
}
